// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rFUl","type":"styles_type__2U5vd","choices":"styles_choices__1YbYv"};